import React, { useState, useEffect } from 'react';
import { Stack, TextField } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../../../../../app/hooks';
import { useUpsertRuleMutation, useDeleteRuleMutation, contractApi } from '../../../../../services/ContractService';
import { RuleCommands } from './RuleCommands';

interface StatusBasedComprehensiveProps {
  ruleId: string;
  ruleString?: string;
  ruleDescription?: string;
}

interface StatusBasedComprehensiveRule {
  category: string;
}

const StatusBasedComprehensive: React.FC<StatusBasedComprehensiveProps> = ({
  ruleId,
  ruleString,
  ruleDescription,
}) => {
  const [searchParams] = useSearchParams();
  const contractId = searchParams.get('id');
  const dispatch = useAppDispatch();
  const [rule, setRule] = useState<StatusBasedComprehensiveRule>({ category: 'J1' });
  
  const [upsertRule] = useUpsertRuleMutation();
  const [deleteRule] = useDeleteRuleMutation();

  useEffect(() => {
    if (ruleString && ruleString !== '') {
      try {
        const parsedRule: StatusBasedComprehensiveRule = JSON.parse(ruleString);
        setRule(parsedRule);
      } catch (error) {
        console.error('Failed to parse rule string:', error);
      }
    }
  }, [ruleString, ruleId]);

  const save = async () => {
    if (!contractId) return;

    try {
      const ruleData = {
        contractId: contractId,
        ruleId: ruleId === '0' ? '' : ruleId,
        ruleType: 'StatusBasedComprehensive',
        priority: 0,
        ruleString: JSON.stringify(rule),
        description: ruleDescription ?? '',
      };

      await upsertRule(ruleData).unwrap();
      dispatch(contractApi.util.invalidateTags(['RuleList']));
    } catch (error) {
      console.error('Failed to save rule:', error);
    }
  };

  const ruleDelete = async () => {
    if (ruleId === '0') return;

    try {
      await deleteRule({ ruleId }).unwrap();
      dispatch(contractApi.util.invalidateTags(['RuleList']));
    } catch (error) {
      console.error('Failed to delete rule:', error);
    }
  };

  return (
    <React.Fragment>
      <Stack direction="row" gap={1} sx={{ mb: 2 }}>
        <TextField
          label="Category"
          value={rule.category}
          sx={{ width: '150px' }}
          onChange={(e) => setRule({ ...rule, category: e.target.value })}
        />
      </Stack>
      <RuleCommands
        saveCommand={save}
        deleteCommand={ruleDelete}
        isNewRule={ruleId === '0'}
      />
    </React.Fragment>
  );
};

export { StatusBasedComprehensive };